import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  tr: {
    translation: {
      // Navigation
      'nav.home': 'Ana Sayfa',
      'nav.exhibitions': 'Sergiler',
      'nav.countries': 'Ülkeler',
      'nav.admin': 'Admin',
      'nav.login': 'Giriş Yap',
      'nav.logout': 'Çıkış Yap',
      'nav.about': 'Hakkımızda',
      'nav.certificates': 'Sertifikalar',
      'nav.careers': 'Kariyer',
      
      // Common
      'common.loading': 'Yükleniyor...',
      'common.error': 'Hata oluştu',
      'common.save': 'Kaydet',
      'common.cancel': 'İptal',
      'common.delete': 'Sil',
      'common.edit': 'Düzenle',
      'common.add': 'Ekle',
      'common.back': 'Geri',
      'common.next': 'İleri',
      'common.previous': 'Önceki',
      'common.close': 'Kapat',
      'common.search': 'Ara',
      'common.filter': 'Filtrele',
      'common.all': 'Tümü',
      'common.yes': 'Evet',
      'common.no': 'Hayır',
      'common.confirm': 'Onayla',
      'common.schedule_call': 'Görüşme Planla',
      
      // Home page
      'home.welcome': 'Hoş Geldiniz',
      'home.description': 'Dünya çapında sergileri keşfedin',
      'home.featured_exhibitions': 'Öne Çıkan Sergiler',
      'home.view_all': 'Tümünü Görüntüle',
      
      // Hero Section
      'hero.global_partner': 'Küresel Tekstil Partneriniz',
      'hero.reliable_production': 'Güvenilir Üretim Yüksek Kalite Kumaşlar',
      'hero.global_partner_desc': 'Tekstil sektöründe güvenilir üretim ve yüksek kalite standartlarıyla hizmet veriyoruz',
      'hero.innovation': 'Tekstilde İnovasyon',
      'hero.premium_solutions': 'Premium Kalite Sürdürülebilir Çözümler',
      'hero.innovation_desc': 'İnovatif çözümlerimizle tekstil üretiminin geleceğini deneyimleyin',
      
      // Products Section
      'products.title': 'Tekstaş Premium Gömlek Kumaşları',
      'products.description': 'Tekstaş Tekstil, yüksek kaliteli gömlek kumaşlarında uzmanlaşmıştır. Kumaşlarımız stil ve dayanıklılığı birleştirerek, hem erkek hem de kadın gömlekleri için mükemmel seçenekler sunar. Modern üretim yöntemleriyle benzersiz, premium kumaşlar üretiyoruz.',
      
      // Features Section
      'features.title': 'Premium Kumaş Koleksiyonumuz',
      'features.description': 'Dikkatle seçilmiş premium kumaş koleksiyonumuzu keşfedin. Nefes alabilir pamuktan lüks ketene ve dayanıklı dimiye kadar, her kumaş gömlekleriniz için stil, konfor ve uzun ömürlü kalite sunmak üzere üretilmiştir.',
      'features.cotton.title': 'Pamuk',
      'features.cotton.description': 'Yumuşak, nefes alabilir ve dayanıklı pamuk kumaşlarımız, tüm gömlek türleri için nihai konfor ve çok yönlülük sunar. Hem günlük hem de resmi giyim için mükemmel olan bu kumaşlar, gün boyunca konforu korurken net bir görünüm sağlar.',
      'features.linen.title': 'Keten',
      'features.linen.description': 'Keten kumaşlarımız hafif, havadar ve sıcak havalar için mükemmeldir. Doğal dokuları ve nefes alabilirlikleriyle bilinen keten gömlekler, rahat ama sofistike bir stil için idealdir.',
      'features.twill.title': 'Dimi',
      'features.twill.description': 'Dimi kumaşlar, pürüzsüz yüzeyleri ve zarif çapraz dokularıyla lüks bir his verir. Bu kumaşlar, zarif ve şık görünümlü, dayanıklı, yüksek kaliteli gömlekler yaratmak için mükemmeldir.',
      
      // Certificates Section
      'certificates.title': 'Sertifikalarımız',
      'certificates.subtitle': 'Tekstil üretiminde mükemmellik standartları',
      'certificates.iso.title': 'ISO 9001:2015',
      'certificates.iso.description': 'Yüksek kaliteli tekstil ürünleri ve hizmetleri sunma taahhüdümüzü garanti eden uluslararası kalite yönetim sistemi sertifikası.',
      'certificates.gots.title': 'GOTS Sertifikası',
      'certificates.gots.description': 'Organik tekstil üretimi ve sürdürülebilir uygulamalara olan bağlılığımızı doğrulayan Küresel Organik Tekstil Standardı sertifikası.',
      
      // Fairs Section
      'fairs.title': 'Fuarlarımız',
      'fairs.subtitle': 'Dünya çapındaki tekstil fuarlarında yerimizi alıyoruz',
      'fairs.view_all': 'Tüm Fuarları Görüntüle',
      
      // Careers Section
      'careers.title': 'Ekibimize Katılın',
      'careers.description': 'Büyüyen ekibimize katılmak için yetenekli bireyler arıyoruz. Tekstil ve inovasyona tutkuluysanız, sizden haber almak isteriz. Başvurunuzu gönderin ve başarı hikayemizin bir parçası olun.',
      'careers.form.full_name': 'Ad Soyad',
      'careers.form.full_name_placeholder': 'Adınızı ve soyadınızı girin',
      'careers.form.email': 'E-posta',
      'careers.form.email_placeholder': 'E-posta adresinizi girin',
      'careers.form.phone': 'Telefon',
      'careers.form.phone_placeholder': 'Telefon numaranızı girin',
      'careers.form.position': 'Pozisyon',
      'careers.form.position_placeholder': 'Başvurduğunuz pozisyon',
      'careers.form.message': 'Mesaj',
      'careers.form.message_placeholder': 'Mesajınız',
      'careers.form.submit': 'Başvuruyu Gönder',
      'careers.success.title': 'Başarılı!',
      'careers.success.message': 'Başvurunuz başarıyla gönderildi. Yakında sizinle iletişime geçeceğiz.',
      'careers.success.close': 'Kapat',
      'careers.error': 'Başvuru gönderilirken hata oluştu. Lütfen tekrar deneyin.',
      
      // Exhibitions
      'exhibitions.title': 'Sergiler',
      'exhibitions.add_new': 'Yeni Sergi Ekle',
      'exhibitions.name': 'Sergi Adı',
      'exhibitions.description': 'Açıklama',
      'exhibitions.country': 'Ülke',
      'exhibitions.city': 'Şehir',
      'exhibitions.date': 'Tarih',
      'exhibitions.start_date': 'Başlangıç Tarihi',
      'exhibitions.end_date': 'Bitiş Tarihi',
      'exhibitions.venue': 'Mekan',
      'exhibitions.organizer': 'Organizatör',
      'exhibitions.website': 'Website',
      'exhibitions.contact': 'İletişim',
      'exhibitions.photos': 'Fotoğraflar',
      'exhibitions.add_photo': 'Fotoğraf Ekle',
      'exhibitions.remove_photo': 'Fotoğrafı Kaldır',
      'exhibitions.no_photos': 'Henüz fotoğraf yok',
      'exhibitions.view_details': 'Detayları Görüntüle',
      'exhibitions.edit_exhibition': 'Sergiyi Düzenle',
      'exhibitions.delete_exhibition': 'Sergiyi Sil',
      'exhibitions.confirm_delete': 'Bu sergiyi silmek istediğinizden emin misiniz?',
      'exhibitions.created_successfully': 'Sergi başarıyla oluşturuldu',
      'exhibitions.updated_successfully': 'Sergi başarıyla güncellendi',
      'exhibitions.deleted_successfully': 'Sergi başarıyla silindi',
      'exhibitions.loading_error': 'Sergiler yüklenirken hata oluştu',
      
      // Countries
      'countries.title': 'Ülkeler',
      'countries.add_new': 'Yeni Ülke Ekle',
      'countries.name': 'Ülke Adı',
      'countries.code': 'Ülke Kodu',
      'countries.flag': 'Bayrak',
      'countries.capital': 'Başkent',
      'countries.population': 'Nüfus',
      'countries.region': 'Bölge',
      'countries.subregion': 'Alt Bölge',
      'countries.languages': 'Diller',
      'countries.currencies': 'Para Birimleri',
      'countries.timezones': 'Saat Dilimleri',
      'countries.view_exhibitions': 'Sergileri Görüntüle',
      'countries.edit_country': 'Ülkeyi Düzenle',
      'countries.delete_country': 'Ülkeyi Sil',
      'countries.confirm_delete': 'Bu ülkeyi silmek istediğinizden emin misiniz?',
      'countries.created_successfully': 'Ülke başarıyla oluşturuldu',
      'countries.updated_successfully': 'Ülke başarıyla güncellendi',
      'countries.deleted_successfully': 'Ülke başarıyla silindi',
      'countries.loading_error': 'Ülkeler yüklenirken hata oluştu',
      
      // Admin
      'admin.title': 'Admin Paneli',
      'admin.dashboard': 'Dashboard',
      'admin.manage_exhibitions': 'Sergileri Yönet',
      'admin.manage_countries': 'Ülkeleri Yönet',
      'admin.manage_users': 'Kullanıcıları Yönet',
      'admin.settings': 'Ayarlar',
      'admin.statistics': 'İstatistikler',
      'admin.total_exhibitions': 'Toplam Sergi',
      'admin.total_countries': 'Toplam Ülke',
      'admin.total_users': 'Toplam Kullanıcı',
      'admin.recent_activity': 'Son Aktiviteler',
      
      // Auth
      'auth.login': 'Giriş Yap',
      'auth.logout': 'Çıkış Yap',
      'auth.register': 'Kayıt Ol',
      'auth.email': 'E-posta',
      'auth.password': 'Şifre',
      'auth.confirm_password': 'Şifreyi Onayla',
      'auth.remember_me': 'Beni Hatırla',
      'auth.forgot_password': 'Şifremi Unuttum',
      'auth.login_successful': 'Başarıyla giriş yapıldı',
      'auth.logout_successful': 'Başarıyla çıkış yapıldı',
      'auth.invalid_credentials': 'Geçersiz e-posta veya şifre',
      'auth.required_field': 'Bu alan zorunludur',
      'auth.invalid_email': 'Geçersiz e-posta adresi',
      'auth.password_mismatch': 'Şifreler eşleşmiyor',
      
      // Forms
      'form.required': 'Bu alan zorunludur',
      'form.invalid_format': 'Geçersiz format',
      'form.min_length': 'En az {{min}} karakter olmalıdır',
      'form.max_length': 'En fazla {{max}} karakter olmalıdır',
      'form.invalid_url': 'Geçersiz URL',
      'form.invalid_date': 'Geçersiz tarih',
      
      // Messages
      'message.success': 'İşlem başarılı',
      'message.error': 'Bir hata oluştu',
      'message.warning': 'Uyarı',
      'message.info': 'Bilgi',
      
      // Language
      'language.turkish': 'Türkçe',
      'language.english': 'English',
      'language.select': 'Dil Seçin',
      'language.change': 'Dili Değiştir',
      
      // Footer
      'footer.description': 'İnovasyon ve kalite ile tekstil üretiminde öncü oluyoruz.',
      'footer.quick_links': 'Hızlı Linkler',
      'footer.about': 'Hakkımızda',
      'footer.careers': 'Kariyer',
      'footer.contact': 'İletişim',
      'footer.email': 'E-posta: info@tekstas.com',
      'footer.phone': 'Telefon: +90 123 456 7890',
      'footer.address': 'Adres: İstanbul, Türkiye',
      'footer.follow_us': 'Bizi Takip Edin',
      'footer.copyright': '© 2023 Tekstas. Tüm hakları saklıdır.'
    }
  },
  en: {
    translation: {
      // Navigation
      'nav.home': 'Home',
      'nav.exhibitions': 'Exhibitions',
      'nav.countries': 'Countries',
      'nav.admin': 'Admin',
      'nav.login': 'Login',
      'nav.logout': 'Logout',
      'nav.about': 'About',
      'nav.certificates': 'Certificates',
      'nav.careers': 'Careers',
      
      // Common
      'common.loading': 'Loading...',
      'common.error': 'An error occurred',
      'common.save': 'Save',
      'common.cancel': 'Cancel',
      'common.delete': 'Delete',
      'common.edit': 'Edit',
      'common.add': 'Add',
      'common.back': 'Back',
      'common.next': 'Next',
      'common.previous': 'Previous',
      'common.close': 'Close',
      'common.search': 'Search',
      'common.filter': 'Filter',
      'common.all': 'All',
      'common.yes': 'Yes',
      'common.no': 'No',
      'common.confirm': 'Confirm',
      'common.schedule_call': 'Schedule a Call',
      
      // Home page
      'home.welcome': 'Welcome',
      'home.description': 'Discover exhibitions around the world',
      'home.featured_exhibitions': 'Featured Exhibitions',
      'home.view_all': 'View All',
      
      // Hero Section
      'hero.global_partner': 'Your Global Textile Partner',
      'hero.reliable_production': 'Reliable Production High Quality Fabrics',
      'hero.global_partner_desc': 'Lorem upsum dolor sit ametLorem upsum dolor sit amet Lorem upsum dolor sit amet',
      'hero.innovation': 'Innovation in Textile',
      'hero.premium_solutions': 'Premium Quality Sustainable Solutions',
      'hero.innovation_desc': 'Experience the future of textile manufacturing with our innovative solutions',
      
      // Products Section
      'products.title': 'Premium Shirt Fabrics by Tekstaş',
      'products.description': 'Tekstaş Textile specializes in high-quality shirt fabrics. Our fabrics combine style and durability, offering the perfect options for both men\'s and women\'s shirts. With modern production methods, we deliver unique, premium fabrics.',
      
      // Features Section
      'features.title': 'Our Premium Fabrics Collection',
      'features.description': 'Explore our carefully curated selection of premium fabrics. From breathable cotton to luxurious linen and durable twill, each fabric is crafted to deliver style, comfort, and long-lasting quality for your shirts.',
      'features.cotton.title': 'Cotton',
      'features.cotton.description': 'Soft, breathable, and durable, our cotton fabrics offer ultimate comfort and versatility for all types of shirts. Perfect for both casual and formal wear, they provide a crisp look while maintaining comfort throughout the day.',
      'features.linen.title': 'Linen',
      'features.linen.description': 'Our linen fabrics are light, airy, and perfect for warm weather. Known for their natural texture and breathability, linen shirts are ideal for a relaxed yet sophisticated style.',
      'features.twill.title': 'Twill',
      'features.twill.description': 'Twill fabrics provide a luxurious feel with their smooth finish and subtle diagonal weave. These fabrics are perfect for creating durable, high-quality shirts with a refined, elegant look.',
      
      // Certificates Section
      'certificates.title': 'Our Certifications',
      'certificates.subtitle': 'Recognized standards of excellence in textile manufacturing',
      'certificates.iso.title': 'ISO 9001:2015',
      'certificates.iso.description': 'International quality management system certification ensuring our commitment to providing high-quality textile products and services.',
      'certificates.gots.title': 'GOTS Certification',
      'certificates.gots.description': 'Global Organic Textile Standard certification confirming our dedication to organic textile production and sustainable practices.',
      
      // Fairs Section
      'fairs.title': 'Our Trade Fairs',
      'fairs.subtitle': 'Taking our place in worldwide textile exhibitions',
      'fairs.view_all': 'View All Fairs',
      
      // Careers Section
      'careers.title': 'Join Our Team',
      'careers.description': 'We\'re always looking for talented individuals to join our growing team. If you\'re passionate about textile and innovation, we\'d love to hear from you. Submit your application and become part of our success story.',
      'careers.form.full_name': 'Full Name',
      'careers.form.full_name_placeholder': 'Enter your full name',
      'careers.form.email': 'Email',
      'careers.form.email_placeholder': 'Enter your email',
      'careers.form.phone': 'Phone',
      'careers.form.phone_placeholder': 'Enter your phone number',
      'careers.form.position': 'Position',
      'careers.form.position_placeholder': 'Position you\'re applying for',
      'careers.form.message': 'Message',
      'careers.form.message_placeholder': 'Your message',
      'careers.form.submit': 'Submit Application',
      'careers.success.title': 'Success!',
      'careers.success.message': 'Your application has been successfully submitted. We will contact you soon.',
      'careers.success.close': 'Close',
      'careers.error': 'Error submitting application. Please try again.',
      
      // Exhibitions
      'exhibitions.title': 'Exhibitions',
      'exhibitions.add_new': 'Add New Exhibition',
      'exhibitions.name': 'Exhibition Name',
      'exhibitions.description': 'Description',
      'exhibitions.country': 'Country',
      'exhibitions.city': 'City',
      'exhibitions.date': 'Date',
      'exhibitions.start_date': 'Start Date',
      'exhibitions.end_date': 'End Date',
      'exhibitions.venue': 'Venue',
      'exhibitions.organizer': 'Organizer',
      'exhibitions.website': 'Website',
      'exhibitions.contact': 'Contact',
      'exhibitions.photos': 'Photos',
      'exhibitions.add_photo': 'Add Photo',
      'exhibitions.remove_photo': 'Remove Photo',
      'exhibitions.no_photos': 'No photos yet',
      'exhibitions.view_details': 'View Details',
      'exhibitions.edit_exhibition': 'Edit Exhibition',
      'exhibitions.delete_exhibition': 'Delete Exhibition',
      'exhibitions.confirm_delete': 'Are you sure you want to delete this exhibition?',
      'exhibitions.created_successfully': 'Exhibition created successfully',
      'exhibitions.updated_successfully': 'Exhibition updated successfully',
      'exhibitions.deleted_successfully': 'Exhibition deleted successfully',
      'exhibitions.loading_error': 'Error loading exhibitions',
      
      // Countries
      'countries.title': 'Countries',
      'countries.add_new': 'Add New Country',
      'countries.name': 'Country Name',
      'countries.code': 'Country Code',
      'countries.flag': 'Flag',
      'countries.capital': 'Capital',
      'countries.population': 'Population',
      'countries.region': 'Region',
      'countries.subregion': 'Subregion',
      'countries.languages': 'Languages',
      'countries.currencies': 'Currencies',
      'countries.timezones': 'Timezones',
      'countries.view_exhibitions': 'View Exhibitions',
      'countries.edit_country': 'Edit Country',
      'countries.delete_country': 'Delete Country',
      'countries.confirm_delete': 'Are you sure you want to delete this country?',
      'countries.created_successfully': 'Country created successfully',
      'countries.updated_successfully': 'Country updated successfully',
      'countries.deleted_successfully': 'Country deleted successfully',
      'countries.loading_error': 'Error loading countries',
      
      // Admin
      'admin.title': 'Admin Panel',
      'admin.dashboard': 'Dashboard',
      'admin.manage_exhibitions': 'Manage Exhibitions',
      'admin.manage_countries': 'Manage Countries',
      'admin.manage_users': 'Manage Users',
      'admin.settings': 'Settings',
      'admin.statistics': 'Statistics',
      'admin.total_exhibitions': 'Total Exhibitions',
      'admin.total_countries': 'Total Countries',
      'admin.total_users': 'Total Users',
      'admin.recent_activity': 'Recent Activity',
      
      // Auth
      'auth.login': 'Login',
      'auth.logout': 'Logout',
      'auth.register': 'Register',
      'auth.email': 'Email',
      'auth.password': 'Password',
      'auth.confirm_password': 'Confirm Password',
      'auth.remember_me': 'Remember Me',
      'auth.forgot_password': 'Forgot Password',
      'auth.login_successful': 'Successfully logged in',
      'auth.logout_successful': 'Successfully logged out',
      'auth.invalid_credentials': 'Invalid email or password',
      'auth.required_field': 'This field is required',
      'auth.invalid_email': 'Invalid email address',
      'auth.password_mismatch': 'Passwords do not match',
      
      // Forms
      'form.required': 'This field is required',
      'form.invalid_format': 'Invalid format',
      'form.min_length': 'Must be at least {{min}} characters',
      'form.max_length': 'Must be at most {{max}} characters',
      'form.invalid_url': 'Invalid URL',
      'form.invalid_date': 'Invalid date',
      
      // Messages
      'message.success': 'Operation successful',
      'message.error': 'An error occurred',
      'message.warning': 'Warning',
      'message.info': 'Information',
      
      // Language
      'language.turkish': 'Türkçe',
      'language.english': 'English',
      'language.select': 'Select Language',
      'language.change': 'Change Language',
      
      // Footer
      'footer.description': 'Leading the way in textile manufacturing with innovation and quality.',
      'footer.quick_links': 'Quick Links',
      'footer.about': 'About',
      'footer.careers': 'Careers',
      'footer.contact': 'Contact',
      'footer.email': 'Email: info@tekstas.com',
      'footer.phone': 'Phone: +90 123 456 7890',
      'footer.address': 'Address: Istanbul, Turkey',
      'footer.follow_us': 'Follow Us',
      'footer.copyright': '© 2023 Tekstas. All rights reserved.'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'tr',
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n; 